export const formatNumber = (
  num: number,
  options: Intl.NumberFormatOptions = {},
) =>
  // TODO parameterize the the locale once go multi-language
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
    ...options,
  }).format(num);

export const formatNumberForDisplayInUnits = ({
  value,
  isPercentageAlreadyMultipliedBy100,
  units,
}: {
  value: number | string;
  isPercentageAlreadyMultipliedBy100: boolean;
  units: 'percentage' | 'dollars' | 'count';
}) => {
  switch (units) {
    case 'percentage':
      const valueNew = isPercentageAlreadyMultipliedBy100
        ? Number(value)
        : Number(value) * 100;

      // converting back to float after rounding removes trailing zeros.
      // e.g.: 75.0 is converted to 75
      return `${Number.parseFloat(valueNew.toFixed(1))}%`;
    case 'dollars':
      return `$${Number(value).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
    default:
      return Number(value).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      });
  }
};
